import store from '../../store/index';
import callRequestApi from '../../api/call-request-api';
import eventBus from '../../common/event-bus/event-bus';
import { mediaQueries } from '../../common/media-query/media-query';
import { mapState, mapActions } from 'vuex';
import { getInit } from '../../common/store/store';
const FORM_STATES = {
	FORM: 'FORM',
	LOADING: 'LOADING',
	ERROR: 'ERROR',
	SUCCESS: 'SUCCESS'
};
const sendStateChangeEvent = (state, id) => {
	const event = new CustomEvent('call-request-state-change', { detail: { state, id } });
	window.dispatchEvent(event);
};
export default {
	props: {
		autoInit: {},
		callerPageType: {
			default: 'PRODUCT_PAGE'
		},
		gaCategory: {},
		id: {
			required: true
		},
		openInModal: {},
		privacyPolicyUrl: {},
		productId: {},
		questionId: {},
		siteId: {
			default: 'portal'
		},
		type: {},
		formal: {
			default: true
		}
	},
	store,
	data() {
		return {
			captcha: null,
			captchaError: false,
			counties: null,
			formState: FORM_STATES.FORM,
			sendCoupon: null,
			sendFailed: false,
			sendSucceeded: false,
			sessionId: null,
			technicalError: false,
			timetable: null,
			validations: null,
			callbackSubjects: []
		};
	},
	mediaQueries,
	watch: {
		formState: {
			async handler(val) {
				await this.$nextTick();
				sendStateChangeEvent(val, this.id);
			},
			immediate: true
		}
	},
	methods: {
		...mapActions(['setVhkId']),
		convertModel(model, type, callerPageType, sessionId, siteId) {
			const modelAssoc = {
				name: 'FIELD_NAME',
				phoneNumber: 'FIELD_MOBILE',
				email: 'FIELD_EMAIL',
				captcha: 'FIELD_CAPTCHA_TEXT',
				time: 'FIELD_CALLBACK_TIME_ID',
				captchaToken: 'FIELD_CAPTCHA_TOKEN',
				other: 'FIELD_OTHER',
				residentialTaxId: 'FIELD_RESIDENTIAL_TAX_ID',
				productId: 'FIELD_PRODUCT_ID',
				[!!this.questionId ? 'questionId' : 'callbackSubject']: 'FIELD_QUESTION_ID',
				companyName: 'FIELD_COMPANY_NAME',
				taxNumber: 'FIELD_COMPANY_TAX_NUMBER',
				taxNumberRequired: 'FIELD_BUSINESS_TYPE',
				county: 'FIELD_MEGYE',
				zipCode: 'FIELD_ZIP_CODE'
			};
			let items = [{ field: 'FIELD_VHK_URL', value: window.location.href }];
			for (let property in model) {
				if (model.hasOwnProperty(property) && !!modelAssoc[property]) {
					items.push({ field: modelAssoc[property], value: model[property] });
				}
			}

			return {
				callerPageType,
				sessionId,
				type,
				siteId,
				items,
				formal: this.formal
			};
		},

		init(payload) {
			callRequestApi
				.getTimetableAndCaptcha(Object.assign({}, payload, { siteId: this.siteId }), this.urlPrefix)
				.then(response => {
					this.timetable = response.data.callbackTimes;
					this.counties = response.data.megyeLista;
					this.sendCoupon = response.data.sendCoupon;
					this.captcha = response.data.captcha;
					this.validations = response.data.fields;
					this.sessionId = response.data.sessionId;
					if (!this.questionId) {
						this.callbackSubjects = response.data.questions;
					}
				})
				.catch(() => {
					this.technicalError = true;
					this.formState = FORM_STATES.ERROR;
				});
		},

		sendCallrequest({ model, type, callerPageType, sessionId, productId, questionId, siteId }) {
			this.formState = FORM_STATES.LOADING;
			this.captchaError = false;
			let sentModel = this.convertModel(model, type, callerPageType, sessionId, siteId);
			callRequestApi
				.sendCallrequest(sentModel, this.urlPrefix)
				.then(response => {
					this.setVhkId(response.data.vhkId);
					this.sendSucceeded = true;
					this.init({ productId, questionId, vhkApplicationType: type }, this.urlPrefix);
					this.formState = FORM_STATES.SUCCESS;
					this.$emit('success');
				})
				.catch(result => {
					if (result.response.status != 409) {
						this.sendFailed = true;
						this.init({ productId, questionId, vhkApplicationType: type }, this.urlPrefix);
						this.$emit('error');
						this.formState = FORM_STATES.ERROR;
					} else {
						this.captcha = result.response.data.captcha;
						this.sessionId = result.response.data.sessionId;
						if (result.response.data.fieldErrors) {
							let captchaErrors = result.response.data.fieldErrors.filter(error => error.fieldType == 'FIELD_CAPTCHA_TEXT');
							if (captchaErrors.length) {
								this.formState = FORM_STATES.FORM;
								this.captchaError = true;
							}
						}
					}
				});
		},

		resetSendState() {
			this.sendSucceeded = false;
			this.sendFailed = false;
			this.captchaError = false;
			this.formState = FORM_STATES.FORM;
		},

		submitCallRequest(model) {
			let mergedModel = Object.assign({}, model, { productId: this.productId, questionId: this.questionId, captchaToken: this.captcha.captchaToken });
			this.sendCallrequest({
				model: mergedModel,
				type: this.type,
				siteId: this.siteId,
				callerPageType: this.callerPageType,
				sessionId: this.sessionId,
				productId: this.productId,
				questionId: this.questionId
			});
		},

		hideCallRequestHeader() {
			Array.from(document.querySelectorAll('.call-request__header')).forEach(item => {
				if (this.sendSucceeded || this.sendFailed) {
					item.style.display = 'none';
				} else {
					item.style.display = 'block';
				}
			});
		}
	},
	computed: {
		...mapState(['urlPrefix']),
		loading() {
			return this.formState == FORM_STATES.LOADING;
		}
	},
	created() {
		eventBus.$on('init-form', ({ id }) => {
			if (id == this.id) {
				this.init({ productId: this.productId, questionId: this.questionId, vhkApplicationType: this.type });
			}
		});
		eventBus.$on('reset-form', ({ id }) => {
			if (id == this.id) {
				this.resetSendState();
			}
		});
		const init = getInit();
		if (this.autoInit || init) {
			eventBus.$emit('init-form', { id: this.id });
		}
		this.hideCallRequestHeader();
		this.$i18n.locale = this.formal ? 'formal' : 'casual';
		sendStateChangeEvent(FORM_STATES.FORM, this.id);
	}
};
